// extracted by css-extract-rspack-plugin
export default {"progressBar":"WKwEwjU5SxAHEPRB"};